module.exports = __webpack_public_path__ + "static/media/fusion.e1ffa381.svg";